import { DefaultTheme } from "styled-components";
import Placeholder from "./assets/placeholders/image-landscape.png";
import Spinner from "./assets/spinner-gold.svg";
import SpinnerBlack from "./assets/spinner-black.svg";
import SpinnerGray from "./assets/spinner-gray.svg";
import CheckeredBackgroundImage from "./assets/placeholders/checkered_background.png";
import { AssetsConfig, UserScript } from "./config";

import { ReactComponent as EchoBg } from "./assets/Clio/echo_background.svg";
import { ReactComponent as Award360White } from "./assets/Clio/Award 360 White.svg";
import { ReactComponent as Award360Black } from "./assets/Clio/Award 360 Black.svg";
import Award360WhitePng from "./assets/Clio/Award 360 White Png.png";
import Award360BlackPng from "./assets/Clio/Award 360 Black Png.png";

import { ReactComponent as NovartisBlack } from "./assets/Awards360/novartisBlack.svg";
import NovartisWhitePng from "./assets/Awards360/NovartisWhite.png";
import NovartisBlackPng from "./assets/Awards360/NovartisWhite.png";

import { ReactComponent as ClioLogo } from "./assets/Clio/clios-horizontal-black.svg";
import ClioLogoPng from "./assets/Clio/CLIOS-Horizontal-Black.png";
import ClioLogoPngWhite from "./assets/Clio/CLIOS-Horizontal-White.png";
import ClioLogoPngSecondaryWhite from "./assets/Clio/CLIOS-Vertical-White.png";
import { ReactComponent as ClioBG } from "./assets/Clio/clio_background.svg";
import SpinnerLoading from "./assets/Clio/clio-loading.svg";
import { ReactComponent as ClioCreditLibrary } from "./assets/Clio/ClioCreditLibrary.svg";
import { ReactComponent as ClioStatue } from "./assets/Clio/ClioStatue.svg";

// global icons
import { ReactComponent as Statue } from "./assets/icons/Statue.svg";
import { ReactComponent as PlusIcon } from "./assets/icons/plus.svg";
import { ReactComponent as CaretDown } from "./assets/icons/Down.svg";
import { ReactComponent as HomeIcon } from "./assets/icons/Programs.svg";
import { ReactComponent as MediaLibIcon } from "./assets/icons/Media Library 2.svg";
import { ReactComponent as EntriesIcon } from "./assets/icons/Media Library.svg";
import { ReactComponent as CheckIcon } from "./assets/icons/Check.svg";
import { ReactComponent as UserIcon } from "./assets/icons/Person.svg";
import { ReactComponent as DownloadIcon } from "./assets/icons/Download.svg";
import { ReactComponent as ClockIcon } from "./assets/icons/Clock.svg";
import { ReactComponent as EditPencilIcon } from "./assets/icons/Write.svg";
import { ReactComponent as CalendarIcon } from "./assets/icons/calendar.svg";
import { ReactComponent as DragArrowsIcon } from "./assets/icons/DragDrop.svg";
import { ReactComponent as ExpandArrowsIcon } from "./assets/icons/Expand.svg";
import { ReactComponent as SearchIcon } from "./assets/icons/Search.svg";
import { ReactComponent as EyeIcon } from "./assets/icons/Preview.svg";
import { ReactComponent as TriangleIcon } from "./assets/icons/Triangle.svg";
import { ReactComponent as CloseIcon } from "./assets/icons/Close.svg";
import { ReactComponent as CloseLarge } from "./assets/icons/CloseLarge.svg";
import { ReactComponent as TrashIcon } from "./assets/icons/Trash.svg";
import { ReactComponent as InvalidIcon } from "./assets/icons/invalid.svg";
import { ReactComponent as InfoIcon } from "./assets/icons/Info.svg";
import { ReactComponent as InfoIcon2 } from "./assets/icons/Info2.svg";
import { ReactComponent as CropIcon } from "./assets/icons/Crop.svg";
import { ReactComponent as CopyIcon } from "./assets/icons/Copy.svg";
import { ReactComponent as UploadIcon } from "./assets/icons/Upload.svg";
import { ReactComponent as ExpandCaret } from "./assets/icons/ExpandCaret.svg";
import { ReactComponent as PlayIcon } from "./assets/icons/Play.svg";
import { ReactComponent as PauseCircleIcon } from "./assets/icons/PauseCircle.svg";
import { ReactComponent as PauseIcon } from "./assets/icons/Pause.svg";
import { ReactComponent as StopIcon } from "./assets/icons/Stop.svg";
import { ReactComponent as LockIcon } from "./assets/icons/Lock.svg";
import { ReactComponent as UnlockedIcon } from "./assets/icons/Unlocked.svg";
import { ReactComponent as SidebarSettingsIcon } from "./assets/icons/SideBarSettings.svg";
import { ReactComponent as SidebarLogoutIcon } from "./assets/icons/SideBarLogout.svg";
import { ReactComponent as SidebarLibraryIcon } from "./assets/icons/SideBarLibrary.svg";
import { ReactComponent as SidebarReportsIcon } from "./assets/icons/SideBarReports.svg";
import { ReactComponent as SidebarJudgeIcon } from "./assets/icons/SideBarJudge.svg";
import { ReactComponent as LibraryIcon } from "./assets/icons/Library.svg";
import { ReactComponent as HelpIcon } from "./assets/icons/Help.svg";
import { ReactComponent as NotesIcon } from "./assets/icons/Notes.svg";
import { ReactComponent as LinkIcon } from "./assets/icons/link.svg";
import { ReactComponent as MediaIcon } from "./assets/icons/Media.svg";
import { ReactComponent as PlayerIcon } from "./assets/icons/Player.svg";
import { ReactComponent as FilterIcon } from "./assets/icons/Filter.svg";
import { ReactComponent as StarIcon } from "./assets/icons/Star.svg";
import { ReactComponent as ListIcon } from "./assets/icons/List.svg";
import { ReactComponent as GridIcon } from "./assets/icons/Grid.svg";
import { ReactComponent as PresentIcon } from "./assets/icons/Present.svg";
import { ReactComponent as StopPresentIcon } from "./assets/icons/StopPresenting.svg";
import { ReactComponent as ZoomIcon } from "./assets/icons/Unzoom.svg";
import { ReactComponent as HideIcon } from "./assets/icons/Hide.svg";
import { ReactComponent as DeselectIcon } from "./assets/icons/Deselect.svg";
import { ReactComponent as TagIcon } from "./assets/icons/Tag.svg";
import { ReactComponent as LikeIcon } from "./assets/icons/Like.svg";
import { ReactComponent as LikedIcon } from "./assets/icons/Liked.svg";
import { ReactComponent as FlagIcon } from "./assets/icons/Flag.svg";
import { ReactComponent as FlaggedIcon } from "./assets/icons/Flagged.svg";
import { ReactComponent as EditUserIcon } from "./assets/icons/EditUser.svg";
import { ReactComponent as DocumentIcon } from "./assets/icons/Doc.svg";
import { ReactComponent as EntryReview } from "./assets/icons/EntryReview.svg";
import { ReactComponent as Cube } from "./assets/icons/Cube.svg";
import { ReactComponent as DocPlay } from "./assets/placeholders/DocPlay.svg";
import { ReactComponent as VideoPlay } from "./assets/placeholders/VideoPlay.svg";
import { ReactComponent as AudioPlay } from "./assets/placeholders/AudioPlay.svg";

import { ReactComponent as JudgingNote } from "./assets/icons/JudgingNote.svg";
import { ReactComponent as JurorFeedback } from "./assets/icons/JurorFeedback.svg";
import { ReactComponent as ReviewerNote } from "./assets/icons/ReviewerNote.svg";
import { ReactComponent as StartMessage } from "./assets/icons/StartMessage.svg";
import { ReactComponent as Bell } from "./assets/icons/Bell.svg";
import { ReactComponent as Juror } from "./assets/icons/Juror.svg";
import { ReactComponent as Ranking } from "./assets/icons/Ranking.svg";
import { ReactComponent as MediaReviewRank } from "./assets/icons/MediaReviewRank.svg";
import { ReactComponent as StarNoFill } from "./assets/icons/StarNoFill.svg";

// alerts
import AlertBlue from "./assets/icons/alert-blue.png";
import AlertBlack from "./assets/icons/alert-black.png";
import AlertGray from "./assets/icons/alert-gray.png";
import AlertWhite from "./assets/icons/alert-white.png";
import AlertGold from "./assets/icons/alert-gold.png";

// animated SVGs
import { ReactComponent as PauseSpinning } from "./assets/icons/Pause-spinning.svg";
import { ReactComponent as PlaySpinning } from "./assets/icons/Play-spinning.svg";
import { ReactComponent as StopSpinning } from "./assets/icons/Stop-spinning.svg";
import NotoSansRegular from "./assets/fonts/NotoSans/NotoSans-Regular.ttf";
import NotoSansSemiBold from "./assets/fonts/NotoSans/NotoSans-SemiBold.ttf";

export const defaultColors = {
	colorPrimaryDark: "#161616",
	colorPrimary: "#FF4E00", // novartis flame orange
	colorPrimaryTint: "rgba(255, 78, 0, 0.75)", // flame orange tint
	colorPrimaryAccent: "#403838", // warm charcoal

	colorActivation: "#BF360C", // burnt orange, novartis link color
	colorActivationDark: "#221F1F", // warm charcoal

	colorButtonPrimary: "rgb(255, 78, 0)", // flame orange
	colorToggleBlue: "#D84315", // hover orange
	colorButtonNavy: "#161616", // novartis ink
	colorNavIcon: "#a8a8a8", // matches inactive nav labels
	colorNavHighlight: "#2A2727", // charcoal, one step up from the nav bar

	colorGrand: "#6E3788",
	colorNoGrand: "#363636",
	colorAwardGold: "#FBCA0E",
	colorAwardSilver: "#ACB6BA",
	colorAwardBronze: "#CD7F32",
	colorShortlist: "#000000",

	colorAwardOne: "#EBF0F6",
	colorAwardTwo: "#D7E2ED",
	colorAwardThree: "#C3D4E4",
	colorAwardFour: "#AFC5DB",
	colorAwardFive: "#9BB7D1",
	colorAwardSix: "#88A9C8",
	colorAwardSeven: "#739ABF",
	colorAwardEight: "#608CB6",
	colorAwardNine: "#4C7DAD",
	colorAwardTen: "#386FA4", // cornflower blue

	// vote button colors
	colorIn: "#014F86", // baby blue
	colorOut: "#A20202", // out red
	colorAbstain: "#666666", // dark gray

	colorDanger: "#A20202", // red
	colorSuccess: "#02c55d", // green
	colorWarning: "#FFF3CD", // yellow

	colorProgressBackground: "#e0e0e0",
	colorProgressBackgroundDark: "#3B3B3B",
	colorSelected: "#d8d8d8",

	colorLogoLightLight: "#FFFFFF",
	colorLogoDarkDark: "#000000",
};

// specific components colors for light theme toggle
const lightComponentColors = {
	colorTextField: "#FFFFFF", // white
	colorProgramCardBody: "#F6F6F6", // off white, matches card container
	colorProgramCardCopy: "#161616", // novartis ink
};

// specific components colors for dark theme toggle
const darkComponentColors = {
	colorTextField: "rgba(69, 69, 69, 0.63)", // transparent gray
	colorProgramCardBody: "#161616", // novartis ink
	colorProgramCardCopy: "#FFFFFF", // white
};

export const lightThemeColors = {
	...lightComponentColors,

	colorBackgroundDark: "#141414", // off black
	colorBackgroundDarkDark: "#161616", // novartis ink
	colorBackgroundLight: "#F6F6F6", // off white
	colorBackgroundLightLight: "#FFFFFF", // white
	colorBackgroundMedium: "#1F1F1F", // dark gray
  
	colorCopyDarkDark: "#000000", // black
	colorCopyDark: "#5F5F5F", // dark gray text
	colorCopyLight: "#a8a8a8", // heathered gray
	colorCopyLightLight: "#FFFFFF", // white
  
	colorLinkLight: "#686868", // light gray
  
	colorButtonDark: "rgb(19, 19, 19)", // off black
	colorButtonLight: "#FFFFFF", // white
  
	colorBorder: "#979797",
	colorBorderLight: "#e8e8e8",
	colorBorderDark: "#121212",
	colorFormText: "#686868",

	colorFieldDisabled: "#CCCCCC",
	colorFieldDisabledDark: "#bbb",
	colorTextDisabled: "#000000",
	colorLabelDisabled: "rgba(0,0,0,0.75)",
	colorFieldReadOnly: "#F0F0F0",

	colorBoxShadow: "rgb(0 0 0 / 15%)", // !!!!!!!!!! NEED TO UPDATE
	gradientBackgroundLight: "rgba(255, 255, 255, 0.9)",
	gradientBackgroundDark: "rgba(0, 0, 0, 0.9)",
	colorBackdropDark: "rgba(0, 0, 0, 0.85)",
};

export const darkThemeColors = {
	...darkComponentColors,

	colorBackgroundDark: lightThemeColors.colorBackgroundLight,
	colorBackgroundDarkDark: lightThemeColors.colorBackgroundLightLight,
	colorBackgroundLight: lightThemeColors.colorBackgroundDark,
	colorBackgroundLightLight: lightThemeColors.colorBackgroundDarkDark,
	colorBackgroundMedium: lightThemeColors.colorBackgroundMedium,

	colorCopyDarkDark: lightThemeColors.colorCopyLightLight,
	colorCopyDark: lightThemeColors.colorCopyLight,
	colorCopyLight: lightThemeColors.colorCopyDark, // heathered gray !!!!!!!!!! NEED TO UPDATE
	colorCopyLightLight: lightThemeColors.colorCopyDarkDark,
  
	colorLinkLight: "#9c9c9c", // light gray
  
	colorButtonDark: lightThemeColors.colorButtonLight,
	colorButtonLight: lightThemeColors.colorButtonDark,
  
	colorBorder: "#979797", // !!!!!!!!!! NEED TO UPDATE
	colorBorderLight: lightThemeColors.colorBorderDark, // !!!!!!!!!! NEED TO UPDATE
	colorBorderDark: lightThemeColors.colorBorderLight, // !!!!!!!!!! NEED TO UPDATE
	colorFormText: "#9c9c9c", // !!!!!!!!!! NEED TO UPDATE
  
	colorFieldDisabled: lightThemeColors.colorFieldDisabled,
	colorFieldDisabledDark: lightThemeColors.colorFieldDisabledDark,
	colorTextDisabled: lightThemeColors.colorTextDisabled,
	colorLabelDisabled: lightThemeColors.colorLabelDisabled,
	colorFieldReadOnly: lightThemeColors.colorFieldReadOnly,
  
	colorBoxShadow: "rgb(0 0 0 / 15%)", // !!!!!!!!!! NEED TO UPDATE
	gradientBackgroundLight: lightThemeColors.gradientBackgroundDark,
	colorPatternBGDark: "rgba(20, 20, 20, 0.9)",
};

export const defaultBoxShadow =
	"0 2px 8px 0 " + lightThemeColors.colorBoxShadow;

export const lightBoxShadow =
	"rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px";

export const gradients = {
	gradientBlackGray: "linear-gradient(180deg, #2A2727 0%, #161616 100%)",
	gradientBlackSlate:
	  "linear-gradient(90deg, rgba(255, 255, 255, 0.5) 16.82%, black 100%)",
	mobileMenu: "linear-gradient(180deg, #2A2727, #161616 20%, #161616)",
};

export const hoverColors = {
	colorButtonHover: "#D84315", // hover orange
	colorButtonDarkHover: "#111111", //dark gray
	colorButtonLightHover: "#DADADA", //slate gray
};

export const pdfColors = {
	textHighlight: "#4a4a4a",
	textLight: "#8e8e8e",
};

export const graphColors = {
	bar: "#141414",
	text: "#666",
	statusColors: {
		a: "#383838",
		b: "#4C4C4C",
		c: "#5F5F5F",
		d: "#717171",
		e: "#8B8B8B",
		f: "#A5A5A5",
		g: "#BDBDBD",
		h: "#D5D5D5",
		i: "#EEEEEE",
		j: "#FAFAFA",
	},
};

const breakpoints = {
	// LOWest TESTED RESOLUTION IS 360
	xxs: "360px",
	xs: "480px",
	sm: "576px",
	md: "768px",
	lg: "992px",
	xl: "1200px",
	xxl: "1400px",
};

const fontSizes = {
	fontBrand: {
		fontFamily: "Inter",
		fontFallback: "sans-serif",
		fontSrc:
			"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
	},
	fontHeading: {
		fontFamily: "Inter",
		fontFallback: "sans-serif",
		fontSrc:
			"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
	},
	fontCopy: {
		fontFamily: "Inter",
		fontFallback: "sans-serif",
		fontSrc:
			"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
	},
		// fontBrand: {
	// 	fontFamily: "Archivo",
	// 	fontFallback: "sans-serif",
	// 	fontSrc:
	// 		"https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100..900;1,100..900&display=swap",
	// },
	// fontHeading: {
	// 	fontFamily: "Roboto",
	// 	fontFallback: "sans-serif",
	// 	fontSrc:
	// 		"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
	// },
	// fontCopy: {
	// 	fontFamily: "Roboto",
	// 	fontFallback: "sans-serif",
	// 	fontSrc:
	// 		"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
	// },
	fontDefaultWeight: "200",
	fontMediumWeight: "300",
	fontSemiBold: "400",

	h1Size: "30px",
	h2Size: "22px",
	h3Size: "18px",
	h4Size: "18px",
	h5Size: "16px",
	h6Size: "14px",
	pSize: "16px",
	aSize: "16px",
	spanSize: "16px",
	xSmallSize: "14px",
	xxSmallSize: "13px",
	xxxSmallSize: "12px",
};

export const lightTheme: DefaultTheme = {
	...defaultColors,
	...lightThemeColors,
	...gradients,
	...hoverColors,
	...fontSizes,
	...breakpoints,
};

export const darkTheme: DefaultTheme = {
	...defaultColors,
	...darkThemeColors,
	...gradients,
	...hoverColors,
	...fontSizes,
	...breakpoints,
};

const userScripts: UserScript[] = [
	// {
	// 	id: "usercentrics-cmp",
	// 	src: "https://web.cmp.usercentrics.eu/ui/loader.js",
	// 	"data-settings-id": "4cuLWYpfErenTA",
	// 	async: true,
	// },
	// {
	// 	src: "https://web.cmp.usercentrics.eu/modules/autoblocker.js",
	// 	loadFirst: true, // only one script should be loadFirst
	// },
];

const assetsConfig: AssetsConfig = {
	companyName: "Awards 360",
	companyNameShort: "a360",
	companyNameLong: "Awards 360",
	holdingCompanyName: "Holding Company",
	agencyNetworkCompanyName: "Agency Network",
	logos: {
	  local: <NovartisBlack title="Logo" />,
	  localPng: NovartisBlackPng,
	  primary: NovartisBlackPng,
	  primaryWhite: NovartisWhitePng,
	  secondary: NovartisBlackPng,
	},
	icons: {
		// clio icons
		creditLibrary: <ClioCreditLibrary title="Credit Library" />,
		statue: <Statue title="Judge" />,

		// global icons
		plus: <PlusIcon title="Plus" />,
		close: <CloseIcon title="Close" />,
		closeLarge: <CloseLarge title="Close" />,
		caret: <CaretDown title="Caret Down" />,
		expand: <ExpandCaret title="Expand" />,
		alertBlue: <img src={AlertBlue} alt="Alert" />,
		alertBlack: <img src={AlertBlack} alt="Alert" />,
		alertGold: <img src={AlertGold} alt="Alert" />,
		alertWhite: <img src={AlertWhite} alt="Alert" />,
		alertGray: <img src={AlertGray} alt="Alert" />,
		home: <HomeIcon title="Home" />,
		mediaLibrary: <MediaLibIcon title="Media Library" />,
		entries: <EntriesIcon title="Entries" />,
		editPencil: <EditPencilIcon title="Edit" />,
		check: <CheckIcon title="Check" />,
		user: <UserIcon title="User" />,
		clock: <ClockIcon title="Clock" />,
		download: <DownloadIcon title="Download" />,
		calendar: <CalendarIcon title="Calendar" />,
		eye: <EyeIcon title="Eye" />,
		triangle: <TriangleIcon title="Triangle" />,
		search: <SearchIcon title="Search" />,
		expandArrows: <ExpandArrowsIcon title="Expand" />,
		dragArrows: <DragArrowsIcon title="Drag" />,
		trash: <TrashIcon title="Trash" />,
		invalid: <InvalidIcon title="Invalid" />,
		info: <InfoIcon title="Info" />,
		info2: <InfoIcon2 title="Info" />,
		crop: <CropIcon title="Crop" />,
		copy: <CopyIcon title="Copy" />,
		upload: <UploadIcon title="Upload" />,
		play: <PlayIcon title="Play" />,
		pause: <PauseIcon title="Pause" />,
		pauseCircle: <PauseCircleIcon title="Pause" />,
		pauseSpinning: <PauseSpinning title="Pause Loading" />,
		playSpinning: <PlaySpinning title="Play Loading" />,
		stop: <StopIcon title="Stop" />,
		stopSpinning: <StopSpinning title="Stop Loading" />,
		lock: <LockIcon title="Lock" />,
		unlocked: <UnlockedIcon title="Unlocked" />,
		gear: <SidebarSettingsIcon title="Settings" />,
		logout: <SidebarLogoutIcon title="Logout" />,
		sidebarLibrary: <SidebarLibraryIcon title="Library" />,
		reports: <SidebarReportsIcon title="Reports" />,
		judge: <SidebarJudgeIcon title="Judge" />,
		library: <LibraryIcon title="Library" />,
		help: <HelpIcon title="Help" />,
		notes: <NotesIcon title="Notes" />,
		link: <LinkIcon title="Link" />,
		document: <DocumentIcon title="Documennt" />,
		docPlay: <DocPlay title="Show Document" />,
		audioPlay: <AudioPlay title="Play Audio" />,
		videoPlay: <VideoPlay title="Play Video" />,
		media: <MediaIcon title="Media" />,
		filter: <FilterIcon title="Filter" />,
		player: <PlayerIcon title="Media Player" />,
		star: <StarIcon title="Star" />,
		list: <ListIcon title="List" />,
		grid: <GridIcon title="Grid" />,
		present: <PresentIcon title="Present Media" />,
		stopPresent: <StopPresentIcon title="Stop Presenting Media" />,
		zoom: <ZoomIcon title="Zoom" />,
		hide: <HideIcon title="Hide" />,
		tag: <TagIcon title="Tag" />,
		deselect: <DeselectIcon title="Deselect" />,
		flag: <FlagIcon title="Flag" />,
		flagged: <FlaggedIcon title="Flagged" />,
		like: <LikeIcon title="Like" />,
		liked: <LikedIcon title="Liked" />,
		editUser: <EditUserIcon title="Edit User" />,
		entryReview: <EntryReview title="Entry Review" />,
		cube: <Cube title="Physical Component" />,
		judgingNote: <JudgingNote title="Judging Note" />,
		jurorFeedback: <JurorFeedback title="Juror Feedback" />,
		reviewerNote: <ReviewerNote title="Reviewer Note" />,
		startMessage: <StartMessage title="Start Message" />,
		bell: <Bell title="Bell" />,
		juror: <Juror title="Juror" />,
		ranking: <Ranking title="Ranking" />,
		mediaReviewRank: <MediaReviewRank title="MediaReviewRank" />,
		starNoFill: <StarNoFill title="Star" />,
	},
	loading: {
		primary: Spinner,
		secondary: Spinner,
		tertiary: SpinnerBlack,
		quaternary: SpinnerGray,
	},
	backgrounds: {
		primary: EchoBg,
	},
	placeholders: {
		image: Placeholder,
		imageBackground: CheckeredBackgroundImage,
	},
	fonts: {
		pdf: {
			activeFont: "primary",
			primary: {
				fontFamily: "Open Sans",
				fontSrc: [
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
						fontWeight: 400,
					},
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
						fontWeight: 600,
					},
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-italic.ttf",
						fontWeight: 400,
						fontStyle: "italic",
					},
				],
			},
			default: {
				fontFamily: "Open Sans",
				fontSrc: [
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
						fontWeight: 400,
					},
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
						fontWeight: 600,
					},
					{
						src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-italic.ttf",
						fontWeight: 400,
						fontStyle: "italic",
					},
				],
			},
			currency: {
				fontFamily: "Noto Sans",
				fontSrc: [
					{
						fontWeight: 400,
						src: NotoSansRegular,
					},
					{
						fontWeight: 600,
						src: NotoSansSemiBold,
					},
				],
			},
		},
	},
	urls: {
		contactEmail: "contact@awards-360.com",
		judgingContactEmail: "contact@awards-360.com",
	},
	colors: lightTheme,
	settings: {
		showHelpWidget: false,
	},
	scripts: userScripts,
};

export default assetsConfig;
